import { z, ZodSchema } from "zod";
import { useMutation } from "@tanstack/react-query";
import { formatFirebaseError } from "@shared/services/api/formatFirebaseError";
import { loginUser } from "../utils/loginUser";
import { AppType } from "@shared/types/app.types";
import { getConfig } from "@shared/services/api/config";

type Args = {
  onSuccess?: (data: any) => void;
  schema: ZodSchema;
  onError?: (error: Error) => void;
};

export function useLoginMutation({ onSuccess, schema, onError }: Args) {
  const { appName } = getConfig();

  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return await loginUser({ appType: appName as AppType, data, onError });
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: (data) => {
      // submit callback
      onSuccess?.(data);
    },
  });
}

export default useLoginMutation;
